import { takeLatest } from 'redux-saga/effects';

import * as mfaActions from '../actions';
import { registerMFAMethodSaga } from './register';
import { completeMFAEnrollmentSaga, verifyMFACodeSaga } from './verify';

/**
 * The root `mfa` saga.
 *
 * @method mfaSaga
 * @type   {Generator}
 */
function* mfaSaga() {
    // Start the enrollment into the method picked on the setup screen.
    yield takeLatest(mfaActions.registerMFAMethod.TRIGGER, registerMFAMethodSaga);
    // Verify the MFA code for the current MFA session.
    yield takeLatest(mfaActions.verifyMFACode.TRIGGER, verifyMFACodeSaga);
    // Complete the sign in once the enrollment success screen is left.
    yield takeLatest(mfaActions.completeMFAEnrollment.TRIGGER, completeMFAEnrollmentSaga);
}

// Default export is the module's root saga.
export default mfaSaga;

// Named exports are all the internal sagas that can be used
// for testing as well as imports in other modules
export { startMFAFlowSaga } from './flow';
export { completeMFAEnrollmentSaga, registerMFAMethodSaga, verifyMFACodeSaga };
